import axios from "axios";
import { apiUrl, loginRoute, refreshRoute, regRoute } from "../static/api";
import { TokenService } from "./tokenService";
import { notification } from "antd";
import { userService } from "./userService";

const axiosInstance = axios.create({
  baseURL: apiUrl || undefined,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = TokenService.getAccessToken();
    if (token) {
      config.headers["authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Token refresh queue to prevent race conditions
let refreshTokenPromise = null;

axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== `${loginRoute}` && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        const refresh = TokenService.getRefreshToken();
        if (!refresh) {
          return Promise.reject(err);
        }

        try {
          // If a refresh is already in progress, wait for it
          if (!refreshTokenPromise) {
            refreshTokenPromise = axios
              .post(
                `${apiUrl}${refreshRoute}`,
                {},
                {
                  headers: {
                    authorization: `Bearer ${refresh}`,
                  },
                }
              )
              .then((rs) => {
                const { accessToken } = rs.data;
                TokenService.updateAccessToken(accessToken);
                return accessToken;
              })
              .finally(() => {
                refreshTokenPromise = null;
              });
          }

          await refreshTokenPromise;
          return axiosInstance(originalConfig);
        } catch (refreshError) {
          const isAuthRoute =
            originalConfig.url?.includes(loginRoute) ||
            originalConfig.url?.includes(regRoute);

          if (!isAuthRoute) {
            notification.error({
              message: "Session expired",
              description: "Please log in again",
            });
            userService.removeUser();
            setTimeout(() => {
              window.location.href = "/";
            }, 100);
          }

          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default axiosInstance;
